class Dismissible {
  constructor() {
    const items = document.querySelectorAll('[data-dismissible]');
    // show/hide alerts based on session or local storage
    items.forEach((item) => {
      const alertId = item.id;
      console.log(item.dataset.dismissalHours);
      const dismissalHours = parseInt(item.dataset.dismissalHours);// || 0;
      console.log(dismissalHours);
      let dismissed = false;
      // if > 0, use local storage w/ expiration
      if (isNaN(dismissalHours)) {
        // cookie
        let expired = checkCookieIsExpired(item.dataset.dismissalKey);
        dismissed = !expired;
      } else if (dismissalHours > 0) {
        const storedTime = parseInt(window.localStorage[alertId]) || 0;
        if (storedTime) {
          // check dismissal expiration
          if (storedTime > (new Date()).getTime()) {
            dismissed = true;
          } else {
            // remove expired dismissal
            window.localStorage.removeItem(alertId);
          }
        }
      }
      // if dismissalHours == 0 use session storage
      else {
        // session
        dismissed = window.sessionStorage[alertId] == 'true';
      }
      if (dismissed) {
        item.setAttribute('data-dismissible', 'dismissed');
      } else {
        item.setAttribute('style', '');
      }
    });

    // wire up for click event
    for (let i = 0; i < items.length; i++) {
      this.makeDismissible(items[i]);
    }
  }

  makeDismissible(item) {
    const close = item.querySelector('[data-dismissible-close]');
    if (!close) return;

    close.addEventListener('click', (e) => {
      e.preventDefault();
      item.setAttribute('data-dismissible', 'dismissed');
      console.log(item.dataset.dismissalHours);
      const dismissalHours = parseInt(item.dataset.dismissalHours);// || 0;
      console.log(dismissalHours);
      if (isNaN(dismissalHours)) {
        // cookie
        setCookie(item.dataset.dismissalKey, 'true', 365);
      } else if (dismissalHours > 0) {
        const expires = new Date();
        expires.setHours(expires.getHours() + dismissalHours);
        window.localStorage[item.id] = expires.getTime();
      } else {
        // session
        window.sessionStorage[item.id] = 'true';
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new Dismissible();
})

function checkCookieIsExpired(cname) {
  let cookie = getCookie(cname);
  if (cookie != '') {
    return false;
  } else {
    return true;
  }
}

function getCookie(cname) {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = 'expires='+ d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}
